import request from '@/utils/request';
import fakeusers from '@/mock/user.data';
import { userServiceV1, notifyServiceV1 } from '@/config/apiPrefix.config';

// 图片验证码
export const getValidationCode = () => request(`${userServiceV1}/code/gen_validation_code`);

// 手机验证码
export const sendPhoneCode = (data) => request(`${userServiceV1}/code/send_phone_code`, {
  params: data,
  isGlobal: true,
});

// 邮箱验证码
export const sendEmailCode = (data) => request(`${userServiceV1}/code/send_email_code`, {
  params: data,
});

// 用户名密码登录
export const loginByUsername = (data) => request(`${userServiceV1}/login/access-token/username`, {
  method: 'post',
  body: data,
});

// 手机号码登录
export const loginByPhone = (data) => request(`${userServiceV1}/login/access-token/phone`, {
  method: 'post',
  body: data,
});

// 注册
export const registration = (data) => request(`${userServiceV1}/users/registration`, {
  method: 'post',
  body: data,
});

// 获取用户信息
export const getUserInfo = () => request(`${userServiceV1}/users/get_user_info`, {
  isGlobal: true,
});

// 更新用户信息
export const updateUserInfo = (data) => request(`${userServiceV1}/users/update_info`, {
  method: 'put',
  body: data,
});

// 修改密码
export const updatePassword = (data) => request(`${userServiceV1}/users/update_password`, {
  method: 'put',
  body: data,
});

// 修改密码
export const updateEmail = (data) => request(`${userServiceV1}/users/update_user_email`, {
  method: 'put',
  body: data,
});

// 验证手机号码
export const checkPhone = (data) => request(`${userServiceV1}/code/check_phone_code`, {
  params: data,
});

// 更新手机号码
export const updatePhone = (data) => request(`${userServiceV1}/users/update_user_phone`, {
  body: data,
  method: 'put',
});

// 忘记密码验证手机号码
export const forgetPasswordCheckPhone = (data) => request(`${userServiceV1}/password-recovery/check_phone_code`, {
  body: data,
  method: 'post',
});

// 忘记密码验证手机号码
export const passwordRecovery = (data) => request(`${userServiceV1}/password-recovery`, {
  body: data,
  method: 'post',
});

// 验证邮箱是否已注册
export const checkEmailExist = (data) => request(`${userServiceV1}/users/check_email_exist`, {
  params: data,
});

// 验证用户是否存在
export const checkUserExist = (data) => request(`${userServiceV1}/users/check_user_exist`, {
  params: data,
});

// 获取用户权限
export const getUserPermission = () => request(`${userServiceV1}/users/get_user_resource`, {
  isGlobal: true,
});

// 购买咨询
export const sendEmail = (data) => request(`${notifyServiceV1}/send/email`, {
  method: 'post',
  body: data,
});

export const verifyPhoneCode = (data) => request(`${userServiceV1}/code/verify_phone_code`, {
  params: data,
});

export const fuzzySearch = (term) => request(`${userServiceV1}/users/fuzzy_search_user`, {
  params: {
    customer_account: term
  }
});

// export const fuzzySearch = (term) => new Promise((resolve, reject) => {
//   const res = fakeusers.filter(u => 
//     u.phone.indexOf(term) > -1 || u.username.indexOf(term) > -1 || u.email.indexOf(term) > -1
//   );
//   resolve(res);
// })

export const consult = (data) => request(`${notifyServiceV1}/send/consult`, {
  method: 'post',
  body: data,
})

export const fuzzySearchWithRole = (term) => request(`${userServiceV1}/users/fuzzy_search_user_with_role`, {
  params: {
    customer_account: term
  }
})